<template>
  <div class="row justify-center items-center circle bg-grey-3 text-grey-7" :style="{ height, width }">
    {{ initials }}
  </div>
</template>

<script>
  export default {
    props: {
      initials: {
        required: true,
        type: String
      },

      height: {
        type: String,
        default: '36px'
      },

      width: {
        type: String,
        default: '36px'
      }
    }
  }
</script>
